<template>
  <div id="EscalationDetail">
    <div id="container">
      <div class="labelTitle lable">エスカレーション詳細</div>
      <div class="button-area">
        <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy">クリップボードにコピー</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <span style="font-size:20px;">エスカレーション</span>
          <b-button class="detailButton is-primary" icon-left="phone-outline" @click="showCall">コール内容参照</b-button>
          <b-button class="detailButton is-primary" style="right: 20px;" icon-left="clipboard-file" @click="showDetail">申込み内容参照</b-button>
          <table>
            <tr>
              <th>エスカレーションID</th>
              <td>{{ escalationId }}</td>
            </tr>
            <tr>
              <th>コール日付</th>
              <td>{{ convertDate(data.callCompDate) }}</td>
            </tr>
            <tr>
              <th>患者コード</th>
              <td>{{ convertDisplayByDeviceType(data.patientCode) }}</td>
            </tr>
            <tr>
              <th>患者名</th>
              <td>{{data.patientName}}</td>
            </tr>
            <tr>
              <th>患者名カナ</th>
              <td>{{data.patientNameKana}}</td>
            </tr>
            <tr>
              <th>連絡先（携帯電話）</th>
              <td>
                {{ convertDisplayByDeviceType(data.patientMobilePhone) }}
              </td>
            </tr>
            <tr>
              <th>連絡（自宅・その他）</th>
              <td>
                {{ data.patientPhoneNumber }}
              </td>
            </tr>
            <tr>
              <th>性別</th>
              <td>{{data.gender}}</td>
            </tr>
            <tr>
              <th>年齢</th>
              <td>{{data.age}}</td>
            </tr>
            <tr>
              <th>医療機関名</th>
              <td>{{ data.medicalInstitutionName }}</td>
            </tr>
            <tr>
              <th>エスカレーション種別<span class="require"/></th>
              <td>
                <select v-model="data.escalationType">
                  <option
                    v-for="type in escalationTypeList"
                    :key="type.code"
                    :value="type.code"
                  >{{ type.name }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th>お客様へのコールバック<span class="require"/></th>
              <td>
                <div>
                  <b-radio class="td_radio" v-model="data.callBack" :native-value="false">不要</b-radio>
                  <b-radio class="td_radio" v-model="data.callBack" :native-value="true">要</b-radio>
                </div>
              </td>
            </tr>
            <tr>
              <th>コールバック時間指定<span class="require"/></th>
              <td><input v-model="data.callBackTime" class="1" name="コールバック時間指定" validate="required"/></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">詳細内容</th>
              <td><textarea v-model="data.escalationContents" maxlength="256" style="resize:vertical;max-width:100%;height:60px;"/></td>
            </tr>
            <tr>
              <th></th>
              <td>※聴取内容、誰からDB希望か、登録先情報の変更、など</td>
            </tr>
            <tr>
              <th>コールセンター架電者名<span class="require"/></th>
              <td><input v-model="data.callStaffName" class="1" name="架電者名" validate="required"/></td>
            </tr>
          </table>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">フィリップス対応</span>
          <table>
            <tr>
              <th>対応状況</th>
              <td>
                <select v-model="data.status">
                  <option v-for="item in cpapCallEscalationStatusList" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>対応日</th>
              <td><input style="width: 200px;" type="date" v-model="data.philipsCorrespondenceDate"/></td>
            </tr>
            <tr>
              <th>対応者名</th>
              <td><input v-model="data.philipsCorrespondenceName"/></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">対応欄</th>
              <td><textarea v-model="data.philipsCorrespondence" maxlength="256" style="resize:vertical;max-width:100%;height:60px;"/></td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="save">保存する</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <floatingDiv v-if="isShowDetail" @close="closeDetail" title="" width="900px" height="480px" :top="dialogTopPostion" right="100px">
      <CpapRequestDetail v-if="callDetailData.deviceTypeCode == 'CPAP'" :data="requestDetailData" :innerUser="true"/>
      <HstRequestDetail v-else-if="callDetailData.deviceTypeCode == 'HST'" :requestDetailData="requestDetailData" />
      <KenshinRequestDetail v-else-if="callDetailData.deviceTypeCode == 'CORP'" :requestDetailData="requestDetailData" />
      <HolterRequestDetail v-else-if="callDetailData.deviceTypeCode == 'HOLTER'" :requestDetailData="requestDetailData" />
    </floatingDiv>
    <floatingDiv v-if="isShowCall" @close="closeDetail" title="" width="900px" height="480px" :top="dialogTopPostion" right="100px">
      <CallDetailCard :callDetailData="callDetailData"/>
    </floatingDiv>
  </div>
</template>
<script>
import {
  cpapCallTypeList,
  cpapCallStatusList,
  cpapCallEscalationStatusList,
  escalationTypeList
} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";
import HstRequestDetail from "../call/components/HstRequestDetailCard.vue";
import KenshinRequestDetail from "../call/components/KenshinRequestDetailCard.vue";
import HolterRequestDetail from "../call/components/HolterRequestDetailCard.vue";
import CallDetailCard from "./components/CallDetailCard.vue";

export default {
  name: "EscalationDetail",
  methods: {
    back: function() {
      if(this.backRoutName){
        this.$router.push({
          name: this.backRoutName,
          params: this.backRoutParams,
        });
      }else{
        this.$router.push({
          name: "EscalationList",
          params: { searchConditions: this.searchParams },
        });
      }
    },
    doSearch: function() {
      var excuteApi = this.getCpapEscalationDetailsPOST;
      var successCallBack = this.getCpapEscalationDetailsPOSTSuccess;
      var errorCallBack = this.getCpapEscalationDetailsPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapEscalationDetailsPOST: function(client) {
      return client.apis.internalCpap.getCpapEscalationDetailsPOST({
        body:{ escalationId: this.escalationId }
      });
    },
    getCpapEscalationDetailsPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj;
      this.callDetailData = this.data.callDetailData;
      this.requestDetailData = this.data.requestDetailData;
    },
    getCpapEscalationDetailsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result.message,this.back());
    },
    showDetail: function() {
      this.closeDetail();
      this.dialogTopPostion = (100 + window.scrollY) + 'px';
      this.isShowDetail = true;
    },
    showCall: function() {
      this.closeDetail();
      this.dialogTopPostion = (100 + window.scrollY) + 'px';
      this.isShowCall = true;
    },
    closeDetail: function() {
      this.isShowDetail = false;
      this.isShowCall = false
    },
    save: function(){
      // バリデーションチェック
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
        return
      }
      // 更新する
      var excuteApi = this.setCpapEscalationDetailsPOST;
      var successCallBack = this.setCpapEscalationDetailsPOSTSuccess;
      var errorCallBack = this.setCpapEscalationDetailsPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapEscalationDetailsPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.philipsCorrespondenceDate = obj.philipsCorrespondenceDate ? obj.philipsCorrespondenceDate.replace(/-/g, "/") : ""
      delete obj.detailData
      return client.apis.internalCpap.setCpapEscalationDetailsPOST({
        body:obj
      });
    },
    setCpapEscalationDetailsPOSTSuccess: function(result) {
      if(this.backRoutName){
        //コール画面からエスカレーション起票で画面遷移した場合、コール画面戻しオブジェクトにエスカレーション内容を設定
        this.backRoutParams["selectData"].escalationId = result.obj.escalationId;
        this.backRoutParams["selectData"].escalationData = {
          callCompDate: this.data.callCompDate,
          patientCode: this.data.patientCode,
          patientName: this.data.patientName,
          patientNameKana: this.data.patientNameKana,
          gender: this.data.gender,
          age: this.data.age,
          escalationType: this.data.escalationType,
          callBack: this.data.callBack,
          callBackTime: this.data.callBackTime,
          escalationContents: this.data.escalationContents,
          callStaffName: this.data.callStaffName,
          escalationType: this.data.escalationType,
          status: this.data.status,
          philipsCorrespondenceDate: this.data.philipsCorrespondenceDate,
          philipsCorrespondenceName: this.data.philipsCorrespondenceName,
          philipsCorrespondence: this.data.philipsCorrespondence,
        }
      }
      this.showSuccess(result);
      this.back();
    },
    setCpapEscalationDetailsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },

    convertDisplayByDeviceType(val) {
      let text = "";
      if(this.callDetailData.deviceTypeCode == "CPAP") {
        text = val;
      } else {
        text = "ー";
      }
      return text;
    },
    convertDate: function(day){
      return day ? day.replace(/-/g, "/") : ""
    },

    clipboardCopy() {
      let copyPasteText = "";
      let headerTextList = [];
      let dataTextList = [];

      Object.values(this.tableNameMap).forEach((val) => {
        headerTextList.push(val.label);

        let content = "";
        switch(val.name) {
          case "patientCode":
          case "patientMobilePhone":
            content = this.convertDisplayByDeviceType(this.data[val.name]);
            break;
          case "escalationType":
            let type = this.escalationTypeList.find(item => item.code == this.data[val.name]);
            content = type ? type.name : "";
            break;
          case "callBack":
            let callBack = this.data[val.name];
            content = callBack ? "要" : "不要";
            break;
          case "status":
            let status = this.cpapCallEscalationStatusList.find(item => item.code == this.data[val.name]);
            content = status ? status.name : "";
            break;
          default:
            content = this.data[val.name];
            content = content ? String(content) : "";
            break;
        }

        content = content ? content.replace(/\r?\n/g, " ") : "";
        dataTextList.push(content);
      });

      copyPasteText = headerTextList.join("\t");
      copyPasteText += "\n";
      copyPasteText += dataTextList.join("\t");

      navigator.clipboard.writeText(copyPasteText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(() => {
          this.showMessage("コピーに失敗しました");
        });
    }
  },
  data() {
    var backRoutName = this.$route.params["name"];
    var backRoutParams = this.$route.params;
    var targetData = this.$route.params["selectData"];
    var searchParams = this.$route.params["searchConditions"];
    var escalationId = this.$route.params["escalationId"];
    var callId = this.$route.params["callId"];
    return {
      backRoutName,
      backRoutParams,
      searchParams,
      targetData,
      escalationId,
      callId,
      data: {},
      requestDetailData: {},
      callDetailData: {},
      afterCall: false,
      isShowDetail: false,
      isShowCall:false,
      dialogTopPostion: 0,
      cpapCallEscalationStatusList:cpapCallEscalationStatusList,
      cpapCallTypeList:cpapCallTypeList,
      cpapCallStatusList:cpapCallStatusList,
      escalationTypeList,
      tableNameMap: {
        // escalation detail
        escalationId: { label: "エスカレーションID", name: "escalationId" },
        callImplementationDate: { label: "コール日付", name: "callCompDate" },
        patientCode: { label: "患者コード", name: "patientCode" },
        patientName: { label: "患者名", name: "patientName" },
        patientNameKana: { label: "患者名（カナ）", name: "patientNameKana" },
        patientMobilePhone: { label: "連絡先（携帯電話）", name: "patientMobilePhone" },
        patientPhoneNumber: { label: "連絡（自宅・その他）", name: "patientPhoneNumber" },
        patientGender: { label: "性別", name: "gender" },
        patientAge: { label: "年齢", name: "age" },
        medicalInstitutionName: { label: "医療機関名", name: "medicalInstitutionName" },
        escalationType: { label: "エスカレーション種別", name: "escalationType" },
        hasCallBack: { label: "お客様へのコールバック", name: "callBack" },
        callBackTime: { label: "コールバック時間指定", name: "callBackTime" },
        detailContent: { label: "詳細内容", name: "escalationContents" },
        callStaffName: { label: "コールセンター架電者名", name: "callStaffName" },
        // philips management
        escalationManagementStatus: { label: "対応状況", name: "status" },
        ManagementDate: { label: "対応日", name: "philipsCorrespondenceDate" },
        ManagerName: { label: "対応者名", name: "philipsCorrespondenceName" },
        ManagementContent: { label: "対応欄", name: "philipsCorrespondence" },
      },
    };
  },
  filters: {
    codeToValueFilter: function(val, list){
      var target = list.find(item => item.code == val)
      if(target){
        return target.name
      }
      return "なし"
    }
  },
  components: {
    floatingDiv: floatingDiv,
    CpapRequestDetail,
    HstRequestDetail,
    KenshinRequestDetail,
    HolterRequestDetail,
    CallDetailCard
  },
  async mounted() {
    if(this.targetData){
      // 遷移元画面で情報を渡している場合(コール詳細から起票)
      this.data = {
        id:0,
        callId:this.callId,
        callCompDate:this.targetData.callCompDate,
        patientCode:this.targetData.patientCode,
        patientName:this.targetData.patientName,
        patientNameKana:this.targetData.patientNameKana,
        patientPhoneNumber:this.targetData.patientPhoneNumber,
        gender:this.targetData.gender,
        age:this.targetData.age,
        escalationType:"",
        callBack:false,
        callBackTime:"",
        escalationContents:"",
        callStaffName:"",
        status:1,
        philipsCorrespondenceDate:null,
        philipsCorrespondenceName:"",
        philipsCorrespondence:""
      }
      this.callDetailData = this.targetData;
      this.requestDetailData = this.targetData.requestDetailData;
    } else {
      this.doSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
input {
  width: 200px;
}
.operation-area {
  width: 1000px;
}
.operation-area::after {
  content: "";
  display: block;
  clear: both;
}
.operationButton {
  width:200px;
}
.red {
    font-weight: bold; 
    color: red;
}
.detailButton {
  width:150px !important;
  height:100% !important;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/escalation/EscalationDetail.vue